import DetailsCardFromLabels from './DetailsCardFromLabels';

export default DetailsCardFromLabels;
